import React from "react";
import { Theme, useTheme, css } from "@emotion/react";

import RoundButton from "core/Components/Buttons/RoundButton";

type Props = {
    buttonData: LinkButton,
    buttonHeight: number,
    buttonSidePadding: number,
};

const Button: React.FC<Props> = ({ buttonData, buttonHeight, buttonSidePadding }) => {
    const theme: Theme = useTheme();

    const linkURL = buttonData.innerURL || buttonData.outerURL;

    if (!buttonData.buttonText || !linkURL) return null;

    const colourTheme = JSON.parse(buttonData.buttonTheme);
    const { buttonTextColour, buttonColour, borderColour } = colourTheme;

    const buttonTextCustomStyle = css`
        font-size: 20px;

        ${theme.breakpoints.up("3xl")} {
            font-size: 25px;
        }

        ${theme.breakpoints.down("sm")} {
            font-size: 16px;
        }
    `;

    return (
        <RoundButton
            backgroundColour={buttonData.buttonColour || buttonColour || theme.colours.transparent}
            borderColour={borderColour}
            textColour={buttonData.buttonTextColour || buttonTextColour}
            textHoverColour={buttonData.buttonTextHoverColour}
            buttonHoverColour={buttonData.buttonHoverColour}
            linkURL={linkURL}
            buttonHeight={buttonHeight}
            buttonSidePadding={buttonSidePadding}
            buttonTextCustomStyle={buttonTextCustomStyle}
        >
            {buttonData.buttonText}
        </RoundButton>
    );
}

export default Button;
